// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cx-header {
  position: relative;
}
.cx-header .cx-header-wrapper {
  padding: 0 30px;
  transition: all 0.5s;
  height: 60px;
  background: #fff !important;
  z-index: 222;
  position: fixed;
  top: 0;
  margin-left: 250px;
  box-shadow: 0px 15px 10px -15px #111;
  width: calc(100% - 250px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cx-header .cx-header-wrapper .main-heading {
  font-size: 20px;
  font-weight: 700;
  color: white;
}
.cx-header .cx-header-wrapper header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.cx-header .cx-header-wrapper header .left {
  padding: 10px 0;
}
.cx-header .cx-header-wrapper header .left img {
  height: 48px;
  width: 48px;
  margin-right: 10px;
}
.cx-header .cx-header-wrapper header .left span {
  text-transform: uppercase;
  color: #22455e;
  font-size: 24px;
  font-weight: 600;
}
.cx-header .cx-header-wrapper header .right img {
  height: 30px;
}
.cx-header .rout-header {
  display: flex;
  align-items: center;
}
.cx-header .rout-header .inner-rout {
  display: flex;
}
.cx-header .rout-header .slash {
  margin: 0 5px;
  font: normal normal 600 16px/23px Overpass;
  letter-spacing: 0.48px;
  color: #ffffff;
}
.cx-header .rout-header label {
  margin-right: 5px;
  display: inline-flex;
  height: 20px;
  width: 20px;
  border: 1px solid #fff;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
}
.cx-header .rout-header label svg {
  transform: rotate(180deg) !important;
  height: 10px;
  margin-left: 5px;
}
.cx-header .rout-header span {
  font: normal normal 600 16px/23px Overpass;
  letter-spacing: 0.48px;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/header.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,eAAA;EACA,oBAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,kBAAA;EACA,oCAAA;EACI,yBAAA;EACR,aAAA;EACA,mBAAA;EACA,yBAAA;AAEA;AADI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AAGN;AAAI;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AAEN;AADM;EACE,eAAA;AAGR;AAFQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAIV;AAFQ;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAIV;AAGQ;EACE,YAAA;AADV;AAOE;EAIE,aAAA;EACA,mBAAA;AARJ;AAII;EACE,aAAA;AAFN;AAMI;EACE,aAAA;EACA,0CAAA;EACA,sBAAA;EACA,cAAA;AAJN;AAMI;EACE,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAJN;AAKM;EACE,oCAAA;EACA,YAAA;EACA,gBAAA;AAHR;AAOI;EACE,0CAAA;EACA,sBAAA;EACA,cAAA;AALN","sourcesContent":[".cx-header {\n  position: relative;\n  .cx-header-wrapper {\n    padding: 0 30px;\n    transition: all 0.5s;\n    height: 60px;\n    background: #fff !important;\n    z-index: 222;\n    position: fixed;\n    top: 0;\n    margin-left: 250px;\n    box-shadow: 0px 15px 10px -15px #111;\n        width: calc(100% - 250px) ;\ndisplay: flex;\nalign-items: center;\njustify-content: flex-end;\n    .main-heading {\n      font-size: 20px;\n      font-weight: 700;\n      color: white;\n    }\n\n    header {\n      align-items: center;\n      display: flex;\n      justify-content: space-between;\n      .left{\n        padding: 10px 0;\n        img{\n          height: 48px;\n          width: 48px;\n          margin-right: 10px;\n        }\n        span{\n          text-transform: uppercase;\n          color: #22455e;\n          font-size: 24px;\n          font-weight: 600;\n        }\n      }\n      .right{\n        .bell{\n          // background: linear-gradient(90deg, #E40288 0.63%, #055D9D 97.5%);\n        }\n        img{\n          height: 30px;\n        }\n      }\n    }\n  }\n\n  .rout-header {\n    .inner-rout {\n      display: flex;\n    }\n    display: flex;\n    align-items: center;\n    .slash {\n      margin: 0 5px;\n      font: normal normal 600 16px/23px Overpass;\n      letter-spacing: 0.48px;\n      color: #ffffff;\n    }\n    label {\n      margin-right: 5px;\n      display: inline-flex;\n      height: 20px;\n      width: 20px;\n      border: 1px solid #fff;\n      border-radius: 50%;\n      align-items: center;\n      justify-content: center;\n      svg {\n        transform: rotate(180deg) !important;\n        height: 10px;\n        margin-left: 5px;\n      }\n    }\n\n    span {\n      font: normal normal 600 16px/23px Overpass;\n      letter-spacing: 0.48px;\n      color: #ffffff;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
